import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/ui/dialog/Dialog';
import MenuItem from 'material-ui/MenuItem';
import translate from 'components/hoc/translate';
import Loader from 'components/loading/Loader';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';

const StyledLoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

class OpenGateModal extends React.Component {
    constructor() {
        super();

        this.state = {
            dialog: false,
        };
    }

    openDialog = () => {
        this.setState({
            dialog: true,
        }, () => {
            setTimeout(this.handleRequest, 2000);
        });
    }

    closeDialog = () => {
        this.setState({
            dialog: false,
        });
    }

    handleRequest = () => {
        const {
            action,
            id,
        } = this.props;

        action(id);
    }

    render() {
        const {
            enabled,
            label,
            title,
            translate,
        } = this.props;

        const {
            dialog,
        } = this.state;

        const actions = [
            <RaisedButton
                key='cancel'
                label={ translate('actions.close') }
                onTouchTap={ () => {
                    this.closeDialog();
                } }
            />,
        ];

        return (
            <div>
                { enabled &&
                    <MenuItem
                        primaryText={ label }
                        onTouchTap={ this.openDialog }
                    />
                }

                <Dialog
                    title={ title }
                    actions={ actions }
                    open={ dialog }
                    modal={ false }
                    onRequestClose={ this.closeDialog }
                >
                    <StyledLoaderWrapper>
                        <Loader />
                    </StyledLoaderWrapper>
                </Dialog>
            </div>
        );
    }
}

OpenGateModal.propTypes = {
    action: PropTypes.func.isRequired,
    enabled: PropTypes.bool,
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    translate: PropTypes.func,
};

export default translate(OpenGateModal);



// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/OpenGateAction.js